const integrationQaDemoGtmConfig: GtmConfig = {
  id: 'GTM-WZQHD6S',
  auth: '-3mmp2rGQlOANvpDXzXl2g',
  preview: 'env-3',
  envName: 'local',
  site: 'app',
};

export const integrationGtmConfig: GtmConfig = {
  ...integrationQaDemoGtmConfig,
  envName: 'integration',
};

export const qaGtmConfig: GtmConfig = {
  ...integrationQaDemoGtmConfig,
  envName: 'qa',
};

export const demoGtmConfig: GtmConfig = {
  ...integrationQaDemoGtmConfig,
  envName: 'demo',
};

export const prodGtmConfig: GtmConfig = {
  id: 'GTM-WZQHD6S',
  auth: 'Wb7qxINM9_86X7k0RFw6lQv',
  preview: 'env-1',
  envName: 'production',
  site: 'app',
};

export interface GtmConfig {
  id: string;
  auth: string;
  preview: string;
  envName: string;
  site: string;
}
